import styled from 'styled-components';
import { color } from '../../theme/Color';

export const KpiMetricsForThreeContainer = styled.div`
  font-family: Inter;
  font-weight: 700;

  margin-left: -20px;
  & .metricsItem {
    padding-left: 20px;
    padding-top: 15px;
  }

  & .metricsDivider {
    border-width: 1px;
    background: ${({ mode }) =>
      mode === 'light' ? color._B2CAEA : color._666666};
    height: 100%;
  }

  & .longMetricsDivider {
    border-width: 1px;
    background: ${({ mode }) =>
      mode === 'light' ? color._B2CAEA : color._666666};
    height: 120%;
  }

  & .metricsData {
    font-size: 16px;
  }

  & .metricsText {
    font-size: 14px;
    color: ${({ mode }) => (mode === 'light' ? color._616161 : color._d0d0d0)};
    font-family: Inter;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    text-transform: capitalize;
  }
`;
